import apiClient from '../../../Services/ApiClient';

export const updateHealthPlanUser = async ({
	healthPlanId,
	healthPlanUserId,
	data,
}: {
	healthPlanId: string;
	healthPlanUserId: string;
	data: object;
}) => {
	return await apiClient.patch(
		`/health-plan/${healthPlanId}/user/${healthPlanUserId}`,
		data,
	);
};

export const updateHealthPlanUserItem = async ({
	healthPlanId,
	healthPlanUserId,
	healthPlanItemId,
	data,
}: {
	healthPlanId: string;
	healthPlanUserId: string;
	healthPlanItemId: string;
	data: object;
}) => {
	return await apiClient.patch(
		`/health-plan/${healthPlanId}/user/${healthPlanUserId}/item/${healthPlanItemId}`,
		data,
	);
};

export const getHealthPlanTimeline = async ({
	healthPlanId,
	healthPlanUserId,
}: {
	healthPlanId: string;
	healthPlanUserId: string;
}) => {
	return await apiClient.get(
		`/health-plan/${healthPlanId}/user/${healthPlanUserId}/item/timeline`,
	);
};
